<template>
  <transition-group name="wipe-left" tag="div" class="notifications-list">
    <component
      class="notification"
      v-for="notification in notifications"
      :is="notification.component"
      v-bind="notification.props"
      :key="notification.id"
      @delete="$emit('delete', notification.id)"
    />
  </transition-group>
</template>

<script>
export default {
  name: "notifications-list",

  props: {
    notifications: Array
  }
};
</script>

<style lang="scss" scoped>
.notifications-list {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  z-index: 45;

  @include desktop {
    width: 25rem;
    margin: 1rem;
  }
}

.notification {
  transition: 0.5s;
  margin: 0;
  position: absolute;
  left: 0;
  bottom: 0;
  opacity: 1;

  &:not(:first-child) {
    bottom: -10rem;
    opacity: 0;
  }
}

.wipe-left {
  &-enter,
  &-leave-to {
    opacity: 0;
    transform: translateX(-100%);
  }

  &-leave-active {
    position: absolute;
  }
}
</style>
